module.exports = __webpack_public_path__ + "img/place-of-worship.50a986fe.svg";